import {Component, input, Input} from '@angular/core';
import {PermissionEnum} from "@app/enums/permissions/PermissionEnum";

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss',
  standalone: false
})
export class SidebarItemComponent {
  @Input() icon: string;
  @Input() imgSrc: string;
  @Input() label: string;
  @Input() route: string | any[];
  @Input() title: string;
  @Input() permission: PermissionEnum
  @Input() isShrunk: boolean = false;
  @Input() isSidebarToggled: boolean = false;
  @Input() customColor: 'orange' | 'default' = 'default';
  @Input() notificationTooltip: string = '';
  notificationCount = input<number>(0);
  showAdditionalText = input<boolean>(false);
  showNewBadge = input<boolean>(false);
}
